import 'base/bolt/setRelativeRoot';
import 'base-styles/reset.sss';
import 'base-styles/boltGlobal.sss';

import { h, render } from 'preact';
import { buildClientStoreData } from 'utils/bolt';
import BoltApp from 'base/bolt/boltApp';
import 'utils/historyPushEvent';

let initialStore = buildClientStoreData(window.__INITIAL_STATE__);

let elem = document.getElementById('app') || document.body;
render(<BoltApp initialStore={initialStore} />, elem, elem.firstChild);
